import { useOutletContext } from 'react-router-dom'
import { AEJ } from 'service/api'

export function useAejOutletContext() {
    return useOutletContext<{
        data: AEJ[]
    }>()
}
